import React from "react";
import EntertainmentCompletionCardPage from "./EntertainmentCompletionCardPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface EntertainmentCompletionCardPageContainerProps extends RouteProps, withValidUserRoleProps {}

const EntertainmentCompletionCardPageContainer = (props: EntertainmentCompletionCardPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <EntertainmentCompletionCardPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(EntertainmentCompletionCardPageContainer);
